import React from 'react';
import {Dialog, DialogBody, DialogFooter, DialogHeader, Text} from '@gravity-ui/uikit';
import {BenefactorTransferDTO} from '../../../../entities';
import {formatNumberWithSpaces} from '../../../../shared';
import styles from './BenefactorTransferConfirmModal.module.scss';
import classNames from 'classnames';

interface SelectedBenefactor {
  id: string;
  displayName: string;
}

interface BenefactorTransferConfirmModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  formData: BenefactorTransferDTO | null;
  selectedBenefactor: SelectedBenefactor | null;
  onConfirm: () => void;
  isLoading: boolean;
}

export const BenefactorTransferConfirmModal = ({
  open,
  setOpen,
  formData,
  selectedBenefactor,
  onConfirm,
  isLoading,
}: BenefactorTransferConfirmModalProps) => {
  if (!formData) return null;

  return (
    <Dialog size="s" hasCloseButton open={open} onClose={() => setOpen(false)}>
      <DialogHeader caption="Проверочный экран" />
      <DialogBody>
        <ul className={styles.list}>
          {selectedBenefactor && (
            <li className={styles.item}>
              <Text variant="subheader-1">Донор сбора:</Text>
              <div className={styles.benefactor}>
                <Text className={styles.value}>{selectedBenefactor.displayName}</Text>
                <Text className={classNames(styles.id, styles.value)}>ID: {selectedBenefactor.id}</Text>
              </div>
            </li>
          )}

          <li className={styles.item}>
            <Text variant="subheader-1">Сумма доната:</Text>
            <Text className={styles.value}>{formatNumberWithSpaces(formData.amount)} ₽</Text>
          </li>

          <li className={styles.item}>
            <Text variant="subheader-1">Комиссия проекта:</Text>
            <Text className={styles.value}>{formData.serviceFee} ₽</Text>
          </li>

          {formData.bookkeepingNumber && (
            <li className={styles.item}>
              <Text variant="subheader-1">Номер договора:</Text>
              <Text className={styles.value}>{formData.bookkeepingNumber}</Text>
            </li>
          )}

          {formData.note && (
            <li className={styles.item}>
              <Text variant="subheader-1">Комментарий для бухгалтера:</Text>
              <Text className={styles.value}>{formData.note}</Text>
            </li>
          )}
        </ul>
      </DialogBody>
      <DialogFooter
        onClickButtonCancel={() => setOpen(false)}
        onClickButtonApply={onConfirm}
        propsButtonApply={{
          size: 'l',
          loading: isLoading,
          view: 'action',
        }}
        propsButtonCancel={{size: 'l'}}
        textButtonApply="Внести средства"
        textButtonCancel="Отменить"
      />
    </Dialog>
  );
};
